import { apiClient } from '@/api/api'
import type {
  CapsuleSurveyConfigResponse,
  CapsuleSurveySubmitBody,
  CapsuleSurveySubmitResponse,
} from './types'

export const CAPSULE_SURVEY_CONFIG_ID = 'default-playground-capsule-create'

/** The one `/playground/*` route without a JWT. */
export const getCapsuleSurveyConfig = async (configId = CAPSULE_SURVEY_CONFIG_ID) => {
  return apiClient.get<CapsuleSurveyConfigResponse>('/playground/capsule-survey/config', {
    params: { config_id: configId },
  })
}

export const submitCapsuleSurvey = async (body: CapsuleSurveySubmitBody) => {
  return apiClient.post<CapsuleSurveySubmitResponse>('/playground/capsule-survey/submit', body)
}
